export const SocialMediaFieldLabel = ({ text }: { text: string }) => {
  return (
    <div className="flex items-center justify-between">
      <label className="font-header text-hoveredSecondary uppercase">
        {text}
      </label>
    </div>
  )
}
